import { Directive, ElementRef, EventEmitter, Inject, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { APP_BASE_HREF } from '@angular/common';

@Directive({
    selector: '[agprDefaultImage]',
    standalone: false
})
export class DefaultImageDirective implements OnChanges {
    @Input() agprDefaultImage: string;
    @Input() set agprImageSrc(src: string) {
        if (src && src !== this._agprImageSrc) {
            this._agprImageSrc = src.replace('http://', 'https://');
            this.setImageSrc(this._agprImageSrc);
        } else if (this.agprDefaultImage) {
            this._agprImageSrc = this.appBaseHref + this.agprDefaultImage;
            this.imageElement.nativeElement.src = this._agprImageSrc;
        }
    };
    @Output() agprFailedToFetchImage: EventEmitter<null> = new EventEmitter<null>();

    _agprImageSrc: string;
    imageElement: ElementRef;

    constructor(el: ElementRef, @Inject(APP_BASE_HREF) private  appBaseHref: string){
        this.imageElement = el;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.hasOwnProperty('agprDefaultImage') && !this.agprImageSrc && this.agprDefaultImage !== undefined) {
            this.imageElement.nativeElement.src = this.appBaseHref + this.agprDefaultImage;
        }
    }

    setImageSrc(url) {
        let img = document.createElement('img');

        img.src = url;

        if (img.complete){
            requestAnimationFrame(() => {
                this.imageElement.nativeElement.src = this._agprImageSrc;
                img.remove();
                img = null;
            });
        } else {
            img.onload = () => {
                this.imageElement.nativeElement.src = this._agprImageSrc;
                img.remove();
                img = null;
            };
            img.onerror = () => {
                this.agprFailedToFetchImage.next(null);
                this.imageElement.nativeElement.src = this.appBaseHref + this.agprDefaultImage;
                img.remove();
                img = null;
            };
        }
    }
}
